<template>
    <div class="index-item-wrap">
        <div class="header-return">
            <el-button type="text" icon="el-icon-arrow-left" @click="returnHistory">返回</el-button>
            <el-button type="success" @click="handleAdd" class="header-btn">新增</el-button>
        </div>

        <el-table :data="crowdActiveProductList" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading">
            <el-table-column prop="activeName" label="众筹名称"></el-table-column>
            <el-table-column prop="proName" label="产品名称"></el-table-column>
            <el-table-column prop="targerPeople" label="目标人数"></el-table-column>
            <el-table-column prop="crowdPrice" label="众筹价格"></el-table-column>
            <el-table-column prop="notice" label="实时话题公告"></el-table-column>
            <el-table-column label="操作" fixed="right" width="250">
                <template slot-scope="scope">
                    <el-button-group>
                        <el-button type="primary" icon="el-icon-edit" size="mini" @click="handleEdit(scope.row)"></el-button>
                        <el-button type="primary" size="mini" @click="handleCrowdProductCoupon(scope.row)">优惠券</el-button>
                        <el-button type="primary" size="mini" @click="handleCrowdProductForum(scope.row)">发券/退款</el-button>
                    </el-button-group>
                </template>
            </el-table-column>
        </el-table>

        <!-- 众筹商品配置 -->
        <el-dialog title="众筹商品配置" :visible.sync="showDialog" center>
            <el-form :model="crowdProduct" :rules="rules" label-width="120px">
                <el-form-item label="拼单id" v-show="false">
                    <el-input v-model="crowdProduct.id" placeholder="众筹id"></el-input>
                </el-form-item>
                <el-form-item label="众筹名称" prop="activeNo">
                    <el-select v-model="crowdProduct.activeNo" clearable placeholder="众筹活动" :disabled="true">
                        <el-option v-for="item in activeList"
                                   :key="item.activeNo"
                                   :label="item.activeName"
                                   :value="item.activeNo">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="众筹商品名称" prop="proId">
                    <el-select v-model="crowdProduct.proId" clearable placeholder="众筹商品名称">
                        <el-option v-for="item in productList"
                                   :key="item.proId"
                                   :label="item.proName"
                                   :value="item.proId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="众筹价格" prop="crowdPrice">
                    <el-input v-model="crowdProduct.crowdPrice" placeholder="众筹价格"></el-input>
                    最终结算使用的是商品的价格，这里配置不生效
                </el-form-item>
                <el-form-item label="目标人数" prop="targerPeople">
                    <el-input v-model="crowdProduct.targerPeople" placeholder="目标人数"></el-input>
                </el-form-item>
                <el-form-item label="虚拟众筹人数" prop="peopleCount">
                    <el-input v-model="crowdProduct.peopleCount" placeholder="虚拟众筹人数"></el-input>
                </el-form-item>
                <el-form-item label="实时话题公告" prop="notice">
                    <el-input v-model="crowdProduct.notice" placeholder="实时话题公告"></el-input>
                </el-form-item>
                <el-form-item label="投票成功后公告" prop="successNotice">
                    <el-input v-model="crowdProduct.successNotice" placeholder="投票成功后公告"></el-input>
                </el-form-item>
                <el-form-item label="回报说明" prop="paybackDesc">
                    <el-input v-model="crowdProduct.paybackDesc" placeholder="回报说明"></el-input>
                </el-form-item>
                 <el-form-item label="拉新奖励金额" prop="newUserAmout">
                    <el-input-number v-model="crowdProduct.newUserAmout" :min="0.00" :precision="2" placeholder="拉新奖励金额"></el-input-number>
                </el-form-item>
                <el-form-item label="老用户奖励金额" prop="oldUserAmout">
                    <el-input-number v-model="crowdProduct.oldUserAmout" :min="0.00" :precision="2" placeholder="老用户奖励金额"></el-input-number>
                </el-form-item>
                <el-form-item label="最大奖励金额" prop="maxAmout">
                    <el-input-number v-model="crowdProduct.maxAmout" :min="0.00" :precision="2" placeholder="最大奖励金额"></el-input-number>
                </el-form-item>
                <el-form-item label="众筹基础金额" prop="baseAmount">
                    <el-input-number v-model="crowdProduct.baseAmount" :min="0.00" :precision="2" placeholder="众筹基础金额"></el-input-number>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="showDialog = false">取 消</el-button>
                <el-button type="primary" @click="saveCrowdProduct()" class="header-btn">
                    保 存
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    //导入 HTTP请求方法
    import {getCrowdActiveProductList,saveCrowdProductConfig,getActiveForOption,getProducts,editCrowdActiveProductInfo} from '../../api/api'

    export default {
        data() {
            return {
                formInline: {
                },
                crowdProduct: {
                    id:0,
                    crowdType:1,
                    activeNo:this.activeNo,
                    notice:'',
                    paybackDesc:'',
                    peopleCount:0,
                    proId:'',
                    successNotice:'',
                    crowdPrice:0,
                    targerPeople:0,
                    newUserAmout:0,
                    oldUserAmout:0,
                    maxAmout:0,
                    baseAmount:0
                },
                showDialog:false,
                activeList: [],
                productList: [],
                activeNo:this.$route.params.activeNo,
                showDialog: false,
                loading: true,
                crowdActiveProductList:[],
                rules: {

                }
            }
        },

        //挂载时候执行
        mounted(){
            //初始化首页数据
            this.handleCrowdActiveProductList(this.activeNo);
            this.getProductList();
            this.getActiveOptionList();
        },

        methods: {
            handleCrowdActiveProductList(activeNo){
                this.loading = true;
                getCrowdActiveProductList({activeNo:activeNo}).then((res) => {
                    if (res.data.status == 200) {
                        this.loading = false;
                        this.crowdActiveProductList = res.data.value;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            returnHistory(){
                window.history.go(-1)
            },

            handleAdd(){
                var d={id:""};
                this.handleEdit(d);
            },

            handleEdit(data){
                this.showDialog = true;
                console.log(data.activeNo);
                if(data.id != ''){
                    editCrowdActiveProductInfo({id:data.id}).then((res) => {
                        this.crowdProduct.activeNo = res.data.value[0].activeNo;
                        this.crowdProduct.id = res.data.value[0].id;
                        this.crowdProduct.notice = res.data.value[0].notice;
                        this.crowdProduct.maxAmout = res.data.value[0].maxAmout;
                        this.crowdProduct.newUserAmout = res.data.value[0].newUserAmout;
                        this.crowdProduct.oldUserAmout = res.data.value[0].oldUserAmout;
                        this.crowdProduct.paybackDesc = res.data.value[0].paybackDesc;
                        this.crowdProduct.peopleCount = res.data.value[0].peopleCount;
                        this.crowdProduct.proId = res.data.value[0].proId;
                        this.crowdProduct.crowdPrice = res.data.value[0].crowdPrice;
                        this.crowdProduct.successNotice = res.data.value[0].successNotice;
                        this.crowdProduct.baseAmount = res.data.value[0].baseAmount;
                        this.crowdProduct.targerPeople = res.data.value[0].targerPeople;
                    });
                }else{
                    this.crowdProduct.activeNo = this.activeNo;
                    this.crowdProduct.id = 0,
                    this.crowdProduct.notice = '';
                    this.crowdProduct.maxAmout = 0;
                    this.crowdProduct.newUserAmout = 0;
                    this.crowdProduct.oldUserAmout = 0;
                    this.crowdProduct.paybackDesc = '';
                    this.crowdProduct.peopleCount = 0;
                    this.crowdProduct.proId = '';
                    this.crowdProduct.crowdPrice = 0;
                    this.crowdProduct.successNotice = '';
                    this.crowdProduct.baseAmount = 0;
                    this.crowdProduct.targerPeople = 0;
                }
            },
            saveCrowdProduct(){
                //保存众筹商品配置
                saveCrowdProductConfig(this.crowdProduct).then((res)=>{
                    if (res.data.status == 200){
                        this.$message.success('保存成功');
                        this.showDialog=false;
                        this.handleCrowdActiveProductList(this.activeNo);
                    }else {
                        this.$message.error('保存失败');
                    }
                });
            },

            getActiveOptionList(){
                if(this.activeList==undefined||this.activeList.length==0){
                    //查询活动选项
                    getActiveForOption({}).then((res) => {
                        //console.log(res);
                        this.activeList = res.data.value;
                    })
                }
            },

            getProductList(){
                if(this.productList.length==0){
                    //查询产品列表
                    getProducts({}).then((res) => {
                        this.productList = res.data.value;
                    })
                }
            },
            handleCrowdProductCoupon(row){
                // this.$router.push({path:'/crowdproductcouponlist/:activeNo/:proId',
                //     name: 'crowdActiveProductList',params:{activeNo:this.activeNo,proId:row.proId}});
                //跳转配置优惠券
                this.$router.push({path: '/crowdCoupon', query: {activeNo: this.activeNo, proName: row.proName,proId:row.proId}});
            },
            handleCrowdProductForum(row){
                this.$router.push({path: '/crowdFundingForumList', query: {activeNo: this.activeNo, proName: row.proName,crowdId:row.id}});
            }
        }
    }
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
    .index-item-wrap{
        padding: 10px 20px;
        .header-return{
            margin-bottom: 20px;
            padding-bottom: 10px;
        }
        .header-btn{
            float: right;
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/crowd/crowdActiveProductList.vue